import React from 'react';
import {useEditorDevice} from 'hooks';
import {Transitioner} from 'components';
import {classNames} from 'utils';

import useProjectStore from '../stores/useProjectStore';
import ProjectURL from './Content/Project.URL';
import ProjectEditor from './Content/Project.Editor';

interface IContentProps {}

const Content = ({}: IContentProps) => {
  const device = useEditorDevice();
  const slug = useProjectStore(s => s.slug);
  const handle = useProjectStore(s => s.creatorHandle) ?? '';
  const link = `app.das-ar.com/ar/${handle}/${slug}`;
  const linkNav = 'https://' + link;

  return (
    <section className="w-full">
      <Transitioner fromY={0} delay={0.25} classNames="h-full">
        <div className="relative flex flex-col h-full items-center">
          <ProjectURL link={link} linkNav={linkNav} />
          <div
            className={classNames(
              'relative flex flex-col items-center duration-300 h-full bg-white shadow-xs overflow-y-scroll',
              device === 'desktop' ? 'w-full' : 'w-100',
            )}>
            <div className="page-container w-full">
              <ProjectEditor />
            </div>
          </div>
        </div>
      </Transitioner>
    </section>
  );
};

export default React.memo(Content);
